import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NMObjectUploadPopup } from "@neumetric/blueprint-lib/flows";
import { riskActions, getUploadRisksResult } from "../../store";
import RiskTemplateFile from "../../assets/others/Mitigator_Risk_Upload_Template.xlsx";

const TITLE = "Upload Risks";
const OBJECT_NAME = "Risk";
const ACCEPT = ".csv,.xls,.xlsx";

const STEPS = [
  "Download the Template provided below.",
  "Prepare existing Risks using this Template.",
  "Import prepared Risks when ready!",
];

export const UploadRiskPopup = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const uploadRisksResult = useSelector(getUploadRisksResult);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  React.useEffect(() => {
    if (open) dispatch(riskActions.clearUploadRisksResult());
  }, [open]);

  const template = {
    name: "Risks_Upload_Template.xlsx",
    path: RiskTemplateFile,
  };

  const handleClose = () => {
    setIsSubmitting(false);
    onClose && onClose();
  };

  const handleUploadConfirm = (files) => {
    if (!files?.length) return;

    const raw = files[0];
    const file = raw.originFileObj || raw;

    setIsSubmitting(true);
    dispatch(riskActions.uploadRisks({ file }));
  };

  return (
    <NMObjectUploadPopup
      key={open ? "open" : "closed"}
      visible={open}
      onModalClose={handleClose}
      onUploadConfirm={handleUploadConfirm}
      isSubmitting={isSubmitting}
      result={uploadRisksResult}
      steps={STEPS}
      template={template}
      accept={ACCEPT}
      multiple={false}
      title={TITLE}
      maskClosable={true}
      objectName={OBJECT_NAME}
    />
  );
};
